(() => {
  const prepareVideo = (video) => {
    if (!video) return;

    // Quita el player nativo SIEMPRE (tu DOM ahora mismo lo está metiendo)
    video.controls = false;
    video.removeAttribute("controls");
    video.setAttribute("controlslist", "nodownload noplaybackrate noremoteplayback");
    video.disablePictureInPicture = true;

    // Requisitos iOS autoplay
    video.muted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    // Autoplay + loop
    video.autoplay = true;
    video.setAttribute("autoplay", "");
    video.loop = true;
    video.setAttribute("loop", "");

    // Preload para que no se quede “muerto” al volver al slide
    video.preload = "auto";
  };

  const safePlay = (video) => {
    if (!video) return;
    prepareVideo(video);
    video.muted = true;
video.setAttribute("muted", "");
video.autoplay = true;
video.setAttribute("autoplay", "");
video.playsInline = true;
video.setAttribute("playsinline", "");
video.setAttribute("webkit-playsinline", "");
video.controls = false;
video.removeAttribute("controls");

    // Si estaba al final, reinicia
    try {
      if (video.ended || (video.duration && video.currentTime >= video.duration - 0.05)) {
        video.currentTime = 0;
      }
    } catch (e) {}

    const p = video.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  };

  const pauseVideo = (video) => {
    if (!video) return;
    try { video.pause(); } catch (e) {}
  };

  const isActiveCandidate = (video) => {
    // Slide activo (varios sliders comunes)
    const slide = video.closest(
      '[aria-hidden="false"], .is-selected, .swiper-slide-active, .slick-current, .active'
    );
    if (slide) return true;

    // Fallback: visible en viewport
    const r = video.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight;
  };

  const refresh = () => {
    const videos = Array.from(document.querySelectorAll("video"));

    // Pausa todo
    videos.forEach(pauseVideo);

    // Play SOLO el que esté “activo”
    videos.forEach((v) => {
      // Limita a galería PDP/medias para no liarla con otros videos del theme
      const inPdp =
        v.closest(".product__media") ||
        v.closest(".media") ||
        v.closest(".product-gallery") ||
        v.closest(".slideshow");

      if (!inPdp) return;

      if (isActiveCandidate(v)) safePlay(v);
    });
  };

  const scheduleRefresh = () => {
    setTimeout(refresh, 60);
    setTimeout(refresh, 220);
    setTimeout(refresh, 500);
  };

  document.addEventListener("DOMContentLoaded", () => {
    refresh();

    // Cambios típicos Shopify
    document.addEventListener("variant:change", scheduleRefresh);
    document.addEventListener("shopify:section:load", scheduleRefresh);

    // Clicks en thumbnails / flechas
    document.addEventListener("click", (e) => {
      const t = e.target;
      if (
        t.closest(".thumbnail") ||
        t.closest(".slider-button") ||
        t.closest("[data-thumbnail]") ||
        t.closest(".swiper-button-next") ||
        t.closest(".swiper-button-prev") ||
        t.closest(".slick-arrow")
      ) {
        scheduleRefresh();
      }
    });

    // Swipe / cambios sin click: observa DOM
    const mo = new MutationObserver(() => {
      clearTimeout(window.__percoVideoTO);
      window.__percoVideoTO = setTimeout(refresh, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true });

   // iOS unlock: con el primer gesto, fuerza play del slide activo
const unlock = () => {
  refresh();                 // inmediato
  setTimeout(refresh, 150);  // reintento (iOS a veces necesita)
  setTimeout(refresh, 600);  // otro reintento
};

window.addEventListener("touchstart", unlock, { passive: true, once: true });
window.addEventListener("pointerdown", unlock, { passive: true, once: true });
window.addEventListener("click", unlock, { passive: true, once: true });
window.addEventListener("scroll", unlock, { passive: true, once: true });
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) {
    refresh();
    setTimeout(refresh, 200);
  }
});
  });
})();